import { useMemo } from 'react';

import { useCountryConfig } from './use-country-config';
import { CountryConfigNames } from '../contexts/country-config-context/country-config-enums';

const getPrioritizedLabelProvidersOrder = (providers = [], preferredLabelProvidersIds = []) => {
  const notFoundRank = 100;
  return providers.toSorted((a, b) => {
    const aIndex = preferredLabelProvidersIds.findIndex((labelProviderId) => labelProviderId === a.providerId);
    const aRank = aIndex === -1 ? notFoundRank : aIndex;
    const bIndex = preferredLabelProvidersIds.findIndex((labelProviderId) => labelProviderId === b.providerId);
    const bRank = bIndex === -1 ? notFoundRank : bIndex;
    return aRank - bRank;
  });
};

export const useWalletedLabelProvidersPreferredOrder = (labelProviders) => {
  const [, preferredWalletedProvidersIds] = useCountryConfig(CountryConfigNames.PreferredWalletedProvidersIds);

  return useMemo(() => {
    if (preferredWalletedProvidersIds?.labelProvidersIds) {
      const sortedLabelProviders = getPrioritizedLabelProvidersOrder(labelProviders, preferredWalletedProvidersIds.labelProvidersIds);
      return sortedLabelProviders;
    }

    return labelProviders;
  }, [labelProviders, preferredWalletedProvidersIds]);
};
